<template>
	<div class="viewer">
		<div class="bg" @click="$emit('close')" />
		<div
			class="slide"
			:class="{ zoomed }"
			v-for="(image, index) in content"
			:key="index"
			v-show="current === index"
		>
			<img :src="image" @click="zoomed = !zoomed" />
		</div>
		<template v-if="content.length > 1">
			<div class="btn right" @click="prev">
				<i class="lni lni-chevron-right"></i>
			</div>
			<div class="btn left" @click="next">
				<i class="lni lni-chevron-left"></i>
			</div>
		</template>
		<div class="close" @click="$emit('close')">
			<i class="lni lni-close"></i>
		</div>
	</div>
</template>

<script>
import { API } from '@/config'

export default {
	name: 'ImageViewer',
	props: {
		content: Array,
	},
	data() {
		return {
			current: 0,
			zoomed: false,
		}
	},
	mounted() {
		window.addEventListener('keydown', this.onEscape)
	},
	destroyed() {
		window.removeEventListener('keydown', this.onEscape)
	},
	methods: {
		next() {
			this.zoomed = false
			if (this.current === this.content.length - 1) this.current = 0
			else this.current += 1
		},
		prev() {
			this.zoomed = false
			if (this.current === 0) this.current = this.content.length - 1
			else this.current -= 1
		},
		onEscape(e) {
			if (e.key !== 'Escape') return
			if (this.zoomed) return (this.zoomed = false)
			this.$emit('close')
		},
	},
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.viewer {
	width: 100%;
	height: 100%;

	.bg {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		cursor: pointer;
	}

	.slide {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		overflow: auto;
		pointer-events: none;

		img {
			pointer-events: all;
			cursor: default;
			display: block;
			height: 100%;
			cursor: zoom-in;
			pointer-events: all;
		}

		&.zoomed {
			display: block;
			pointer-events: all;

			img {
				height: fit-content;
				cursor: zoom-out;
			}
		}
	}

	.btn {
		width: 25%;
		height: 100%;
		position: absolute;
		cursor: pointer;
		opacity: 0.5;
		font-size: 24px;
		color: #fff;
		display: flex;
		align-items: center;
		padding: 0 20px;

		&:hover {
			opacity: 1;
		}

		&:active i {
			transform: scale(0.9);
		}

		&.left {
			left: 0;
			top: 0;
		}

		&.right {
			right: 0;
			top: 0;
			justify-content: flex-end;
		}
	}

	.close {
		width: 100%;
		height: 100px;
		position: absolute;
		top: 0;
		left: 0;
		cursor: pointer;
		opacity: 0.5;
		text-align: right;
		font-size: 24px;
		color: #fff;

		&:hover {
			opacity: 1;
		}

		i {
			padding: 13px;
		}
	}
}
</style>
